import * as Types from 'apps/shared/scripts/__generated__/graphql.generated';

import { gql } from '@apollo/client';
export type DesignFragment = { readonly __typename: 'Design', readonly color: string, readonly id: string, readonly name: string, readonly background: { readonly __typename: 'Background', readonly attachment: string, readonly color: string, readonly size: string, readonly src: string } };

export const DesignFragmentDoc = gql`
    fragment DesignFragment on Design {
  background {
    attachment
    color
    size
    src
  }
  color
  id
  name
}
    `;